const baseUrl = "/api";
export const imagesUrl =
    process.env.NODE_ENV === "production" ? "/images/" : "http://localhost:8000/images/"; // ändrade från 10.0.0.18
type Params = {
    [key: string]: string;
};

// export const setEndpoint = (endpoint: Endpoint, params?: Params) => {
//     let url = baseUrl + endpoint;

//     if (process.env.NODE_ENV === "development") {
//         url = "http://localhost:8000" + url;
//     }

//     if (params) {
//         Object.keys(params).forEach(key => {
//             url = url.replace(`:${key}`, params[key]);
//         });
//     }

//     return url;
// };
export const setEndpoint = (endpoint: Endpoint, params?: Record<string, string | string[]>) => {
    let url = baseUrl + endpoint;

    if (process.env.NODE_ENV === "development") {
        url = "http://localhost:8000" + url; // 172.21.54.159 use this when developing locally
    }

    const queryParams: string[] = [];

    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            const pathParam = `:${key}`;
            if (url.includes(pathParam)) {
                url = url.replace(pathParam, encodeURIComponent(String(value)));
            } else {
                const encodedValue = Array.isArray(value) ? value.join(",") : value;
                queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`);
            }
        });
    }

    if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
    }

    return url;
};

export enum Endpoint {
    login = "/auth/login",
    logout = "/auth/logout",
    accessToken = "/auth/access-token",
    changePassword = "/auth/change-password",
    forgotPassword = "/auth/forgot-password",
    resetPassword = "/auth/reset-password",
    resetPasswordToken = "/auth/reset-password-token",
    registerInterest = "/auth/register-interest",

    companies = "/companies",
    company = "/companies/:companyId",
    subCompany = "/companies/subCompany",
    subCompanies = "/companies/:companyId/subCompanies",
    topCompany = "/companies/:companyId/topCompany",

    employees = "/companies/:companyId/employees",
    employee = "/companies/:companyId/employees/:employeeId",
    changeLanguage = "/companies/:companyId/employees/:employeeId/language",

    inventories = "/companies/:companyId/inventories",
    inventory = "/companies/:companyId/inventories/:inventoryId",

    mergeInventory = "/inventories/merge",
    productsMerged = "/companies/:companyId/inventories/:inventoryId/products/merged/:mergedInventoryId",

    products = "/companies/:companyId/inventories/:inventoryId/products",
    product = "/companies/:companyId/inventories/:inventoryId/products/:productId",
    predictProduct = "/companies/:companyId/inventories/:inventoryId/products/predict",

    manufacturers = "/manufacturers",
    designers = "/designers",
    categories = "/categories",
    mainCategories = "/maincategories",
    productStatuses = "/product-statuses",
    actions = "/actions",
    colors = "/colors",
    collaboration = "/collaborations",
    materials = "/materials",

    productReport = "/companies/:companyId/inventories/:inventoryId/products/report",
    mergedProductReport = "/companies/:companyId/inventories/:inventoryId/products/merged/:mergedInventoryId/report",

    loginLink = "/loginLink/:id",
}
